import * as React from 'react';
import { EmployeeChart } from './EmployeeChart';
import { EmployeeAgencyChart } from './EmployeeAgencyChart';
import MapContainer from '../../Common/MapContainer';

import ZoomHelp from './ZoomHelp';
import { FilterUserState, SpendingReportState } from '../../../interface/MyInterfaces';

import renderHTML from 'react-render-html';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';


class AggregateTab extends React.Component<FilterUserState & SpendingReportState, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        var chart3_text = this.props.SpendingReport_AggTab && this.props.SpendingReport_AggTab.chart3_text && this.props.SpendingReport_AggTab.chart3_text != "" && renderHTML(this.props.SpendingReport_AggTab.chart3_text);
        return <div className='tabcontents container-fluid'>
            <div className="row row__header">
                <div className="report__firstline">
                    <div>
                        <h1>{this.props.SpendingReport_AggTab && this.props.SpendingReport_AggTab.header}</h1>
                    </div>
                    <div>
                        <img height='80px' src={'/dist/univ_logos/' +  this.props.UserState.report_display_id  + '.png'} alt='Logo'></img>
                    </div>
                </div>
                <h3>{this.props.SpendingReport_AggTab && this.props.SpendingReport_AggTab.sub_header}</h3>
                {this.props.SpendingReport_AggTab && renderHTML(this.props.SpendingReport_AggTab.report_text)}
            </div>
            <div className='row'>
                <div className="col-md-6">
                    <h4 style={{paddingBottom:"10px"}}>{this.props.SpendingReport_AggTab && this.props.SpendingReport_AggTab.chart1_main_title}</h4>
                    <div className="chartcontainer">
                        {this.props.SpendingEmployeeChart_Aggregate.length>0 && <ZoomHelp className="zoomhelp chart1" chart_no={7} />}
                        <EmployeeChart
                            refresh_className={"fa fa-refresh refresh"}
                            normal_or_large={0}
                            SpendingEmployeeChart_Data={this.props.SpendingEmployeeChart_Data}
                            SpendingEmployeeChart_Years={this.props.SpendingEmployeeChart_Years}
                            SpendingReport_Tab1={this.props.SpendingReport_AggTab}
                            SpendingEmployeeChart={this.props.SpendingEmployeeChart_Aggregate}
                            FilterState={this.props.FilterState}
                            agg={1} />
                    </div>
                </div>
                <div className="col-md-6">
                    <h4>Organization of the Scientific Workforce</h4>
                    <div className="chartcontainer">
                        <ZoomHelp className="zoomhelp" chart_no={8} />
                        <EmployeeAgencyChart
                            normal_or_large={0}
                            SpendingEmployeeAgencyChart_Data={this.props.SpendingEmployeeAgencyChart_Data}
                            SpendingReport_Tab1={this.props.SpendingReport_AggTab}
                            SpendingEmployeeAgencyChart={this.props.SpendingEmployeeAgencyChart_Aggregate}
                            FilterState={this.props.FilterState}
                            agg={1} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-5 load_spending_expenditure_map'>
                    <h4>National Distribution of Research-Related Expenditures</h4>
                    <div>{chart3_text}</div>
                </div>
                <div className="chartcontainer col-md-7">
                    <h5>Total vendor & subaward expenditures on {this.props.FilterState.report_type} research awards to {this.props.FilterState && this.props.FilterState.agg_schools.length} IRIS member universities for {"FY " + this.props.FilterState.bench_year}*</h5>
                    <ZoomHelp className="zoomhelpmap" chart_no={9} />
                    {
                        (this.props.SpendingReportConf && this.props.SpendingExpenditureMap_Aggregate && this.props.SpendingExpenditureMap_Aggregate.length > 0)
                            ?<MapContainer
                                isInState={false}
                                isZoomed={false}
                                isCongress={false}
                                state_fips={this.props.SpendingReportConf.state_fips}
                                mapData={this.props.SpendingExpenditureMap_Aggregate}
                                USState={this.props.USStateList}
                            />
                            : <div>loading <i className="fa fa-spinner"></i></div>                   
                     }
                </div>
            </div>
        </div>;
    }
}

export default withUserActionTracker(AggregateTab, "Spending Report", "viewed Aggregate Tab")